/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmAppSwitchPaymentRequest
 */
export interface ConfirmAppSwitchPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmAppSwitchPaymentRequest
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmAppSwitchPaymentRequest
     */
    paymentReference: string;
    /**
     * 
     * @type {ConfirmAppSwitchPaymentRequestResultEnum}
     * @memberof ConfirmAppSwitchPaymentRequest
     */
    result: ConfirmAppSwitchPaymentRequestResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfirmAppSwitchPaymentRequest
     */
    requestId?: string | null;
    /**
     * 
     * @type {ConfirmAppSwitchPaymentRequestTypeEnum}
     * @memberof ConfirmAppSwitchPaymentRequest
     */
    type?: ConfirmAppSwitchPaymentRequestTypeEnum | null;
}


/**
 * @export
 */
export const ConfirmAppSwitchPaymentRequestResultEnum = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    CANCELLED: 'CANCELLED'
} as const;
export type ConfirmAppSwitchPaymentRequestResultEnum = typeof ConfirmAppSwitchPaymentRequestResultEnum[keyof typeof ConfirmAppSwitchPaymentRequestResultEnum];

/**
 * @export
 */
export const ConfirmAppSwitchPaymentRequestTypeEnum = {
    PAYMENT: 'PAYMENT',
    REFUND: 'REFUND'
} as const;
export type ConfirmAppSwitchPaymentRequestTypeEnum = typeof ConfirmAppSwitchPaymentRequestTypeEnum[keyof typeof ConfirmAppSwitchPaymentRequestTypeEnum];


/**
 * Check if a given object implements the ConfirmAppSwitchPaymentRequest interface.
 */
export function instanceOfConfirmAppSwitchPaymentRequest(value: object): value is ConfirmAppSwitchPaymentRequest {
    if (!('paymentMethodId' in value) || value['paymentMethodId'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function ConfirmAppSwitchPaymentRequestFromJSON(json: any): ConfirmAppSwitchPaymentRequest {
    return ConfirmAppSwitchPaymentRequestFromJSONTyped(json, false);
}

export function ConfirmAppSwitchPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmAppSwitchPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethodId': json['paymentMethodId'],
        'paymentReference': json['paymentReference'],
        'result': json['result'],
        'requestId': json['requestId'] === undefined ? undefined : json['requestId'] === null ? null : json['requestId'],
        'type': json['type'] === undefined ? undefined : json['type'] === null ? null : json['type'],
    };
}

export function ConfirmAppSwitchPaymentRequestToJSON(json: any): ConfirmAppSwitchPaymentRequest {
    return ConfirmAppSwitchPaymentRequestToJSONTyped(json, false);
}

export function ConfirmAppSwitchPaymentRequestToJSONTyped(value?: ConfirmAppSwitchPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethodId': value['paymentMethodId'],
        'paymentReference': value['paymentReference'],
        'result': value['result'],
        'requestId': value['requestId'],
        'type': value['type'],
    };
}

